import * as S from './style';

export function LoadingOnPage() {
  return (
    <S.LoadingContent>
      <div className="spinner"></div>
      <div className="text">Carregando...</div>
    </S.LoadingContent>
  )
}